import React from 'react'
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Alert, Button, Col, Row, FormGroup, FormLabel, FormControl, Modal, ModalTitle } from 'react-bootstrap'
import './OpticianProfile.css'

const OpticianProfile = ({
        isOpen,
        errorMessage,
        updateOptician,
        closeDialog,
        opticianForm,
        roles
    }) => {

    const organizationId = opticianForm && opticianForm.organizationId;

    // Check if user is admin (can edit)
    const isAdmin = roles && roles.some(role => role === 'ROLE_OPTICIAN_ADMIN' || role === 'ROLE_ADMIN');
    const readOnly = !isAdmin;

    const validationSchema = Yup.object().shape({
        name: Yup.string().max(150, "Max 150 tecken").required("Obligatoriskt fält"),
        streetAddress: Yup.string().max(150, "Max 150 tecken"),
        zipCode: Yup.string().max(10, "Max 10 tecken"),
        city: Yup.string().max(100, "Max 100 tecken"),
        contactName: Yup.string().max(100, "Max 100 tecken"),
        contactPhoneNumber: Yup.string().max(20, "Max 20 tecken"),
    });

    return (
        isOpen &&
        (<Modal
            show={true}
            onHide={closeDialog}
            backdrop="static"
            keyboard={true}
            size="lg"
        >
            <div className="SaveOpticianDialog">
                <Modal.Header closeButton>
                    <ModalTitle>
                        <h3>Min organisation</h3>
                    </ModalTitle>
                </Modal.Header>
                <Modal.Body>
                    {errorMessage &&
                    <Alert variant="danger">{errorMessage}</Alert>
                    }
                    <Formik
                        initialValues={{
                            name: (opticianForm && opticianForm.name) || "",
                            streetAddress: (opticianForm && opticianForm.streetAddress) || "",
                            zipCode: (opticianForm && opticianForm.zipCode) || "",
                            city: (opticianForm && opticianForm.city) || "",
                            contactName: (opticianForm && opticianForm.contactName) || "",
                            contactPhoneNumber: (opticianForm && opticianForm.contactPhoneNumber) || "",
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            updateOptician({
                                organizationId: organizationId,
                                ...values,
                            });
                        }}
                    >
                    {() => (
                    <Form id="saveOpticianForm" className="SaveOpticianForm">
                        <Row>
                            <Col sm={12}>

                                <FormGroup className="mb-3">
                                    <FormLabel>Företagets eller butikens namn</FormLabel>
                                    <Field as={FormControl} type="text" name="name" readOnly={readOnly} placeholder="Företagets namn" />
                                    <ErrorMessage name="name" component="div" className="text-danger small" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Gatuadress</FormLabel>
                                    <Field as={FormControl} type="text" name="streetAddress" readOnly={readOnly} placeholder="Ex: Stora Torget 1B" />
                                    <ErrorMessage name="streetAddress" component="div" className="text-danger small" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Postnummer</FormLabel>
                                    <Field as={FormControl} type="text" name="zipCode" readOnly={readOnly} placeholder="Ex: 112 12" />
                                    <ErrorMessage name="zipCode" component="div" className="text-danger small" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Stad</FormLabel>
                                    <Field as={FormControl} type="text" name="city" readOnly={readOnly} placeholder="Stad" />
                                    <ErrorMessage name="city" component="div" className="text-danger small" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Namn på kontaktperson</FormLabel>
                                    <Field as={FormControl} type="text" name="contactName" readOnly={readOnly} placeholder="För- och efternamn" />
                                    <ErrorMessage name="contactName" component="div" className="text-danger small" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <FormLabel>Telefonnummer för kontakt</FormLabel>
                                    <Field as={FormControl} type="text" name="contactPhoneNumber" readOnly={readOnly} placeholder="Telefonnummer" />
                                    <ErrorMessage name="contactPhoneNumber" component="div" className="text-danger small" />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Col
                                    xs={5}
                                    style={{ display: "flex", justifyContent: "flex-end" }}
                                >
                                    <Button variant={'danger'} onClick={closeDialog} style={{marginLeft: '5px'}}>
                                        {readOnly ? 'Stäng' : 'Avbryt'}
                                    </Button>
                                    {!readOnly && (
                                        <Button type="submit" variant={'primary'} style={{marginLeft: '5px'}}>Spara</Button>
                                    )}
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                    )}
                    </Formik>
                </Modal.Body>
            </div>
        </Modal>)
    )}
export default OpticianProfile;
